import { DetailFile, CaseResponse, ComplaintResponse, FileResponse } from '@/types/types';

export const getCaseFiles = (caseResponse: CaseResponse): DetailFile[] => {
	if (!caseResponse) return [];

	let files = [] as DetailFile[];
	caseResponse.files?.forEach((file) => {
		files.push({
			file: {
				...file,
				bytes: null,
			},
			isNew: false,
		});
	});

	caseResponse.complaints?.forEach((complaint) => {
		complaint.files?.forEach((file) => {
			files.push({
				file: {
					...file,
					bytes: null,
				},
				isNew: false,
			});
		});

		complaint.callbacks?.forEach((callback) => {
			callback.files?.forEach((file) => {
				files.push({
					file: {
						...file,
						bytes: null,
					},
					isNew: false,
				});
			});
		});
	});
	caseResponse.statements?.forEach((statement) => {
		statement.files?.forEach((file) => {
			files.push({
				file: {
					...file,
					bytes: null,
				},
				isNew: false,
			});
		});
	});

	return files;
};

export const getComplaintFiles = (complaintResponse: ComplaintResponse): DetailFile[] => {
	if (!complaintResponse) return [];
	let files = [] as DetailFile[];
	complaintResponse.files?.forEach((file) => {
		files.push({
			file: {
				...file,
				bytes: null,
			},
			isNew: false,
		});
	});

	complaintResponse.callbacks?.forEach((callback) => {
		callback.files?.forEach((file) => {
			files.push({
				file: {
					...file,
					bytes: null,
				},
				isNew: false,
			});
		});
	});
	return files;
};

export const getShowUrl = (file) => {
	if (!file.file?.id || !file.file?.fileName) return '';

	/* add show endpoint to show file in new tab */
	return '/werberat-backend/show/' + file.file.id + '/' + file.file.fileName;
};

export const isImage = (file: FileResponse) => {
	return file.contentType.includes('image');
};
export const isPdf = (file: FileResponse) => {
	return file.contentType.includes('pdf');
};
export const isVideo = (file: FileResponse) => {
	return file.contentType.includes('video');
};
export const isAudio = (file: FileResponse) => {
	return file.contentType.includes('audio');
};

export const fileNameWithoutExtension = (fileName: string) => {
	const extensionIndex = fileName.lastIndexOf('.');
	let name = fileName.slice(0, extensionIndex);
	if (name.length > 21) {
		name = name.slice(0, 21) + '...';
	}
	return name;
};
export const fileExtension = (fileName: string) => {
	const extensionIndex = fileName.lastIndexOf('.');
	return fileName.slice(extensionIndex);
};
